import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';

import { SELLER_USER, UPDATE_SELLER_USER } from './queries';
import { ButtonContainer } from './elements';
import { NOTIFICATION_OPTIONS } from './index';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EditSellerUser = ({setShowModal, refetch, sellerUser, setUpdatedSellerUserDetails}) => {
  const [submitting, setSubmitting] = useState();
  const [updateSellerUser] = useMutation(UPDATE_SELLER_USER, {
    onCompleted: (response) => {
      if(refetch) {
        refetch();
      }
      setUpdatedSellerUserDetails(response?.updateSellerUser?.sellerUser, false);
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    updateSellerUser({ variables: input });
  });

  // const [ loadSellerUser, { loading: loading, data: data } ] =
  // useLazyQuery(SELLER_USER, {onCompleted: refetch});

  // if (sellerUser === undefined && id && !loading) {
  //   loadSellerUser({ variables: { id } });
  // }

  const { control, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: {
      id: sellerUser?.id,
      firstName: sellerUser?.firstName || '',
      lastName: sellerUser?.lastName || '',
      email: sellerUser?.email || '',
      role: sellerUser?.role || '',
      assetNotifications:
        sellerUser?.assetNotifications || 'include_unassigned',
    }
  });

  return (
    <View>
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Email is required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "Email should have at most 50 characters",
                matchPattern: (v) => EMAIL.test(v) ||
                  "Must be a valid email address",
              },
            })}
          />
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Role:"
            name="role"
            options={[
              { value: 'Admin', label: 'Admin' },
              { value: 'Normal', label: 'Normal' },
            ]}
            control={control}
            errors={errors}
          />
          <Input.Picker
            label="Receive asset notifications:"
            name="assetNotifications"
            options={NOTIFICATION_OPTIONS}
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Seller User" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditSellerUser;
